import { useCallback } from 'react'
import dynamicYieldEvents from 'src/utils/dynamicYield/dynamicYieldEvents'

import { useCheckout } from '../checkout/useCheckout'
import type { Item } from '../checkout/entity/orderForm'

export const useRemoveButton = (item: Item) => {
  const { updateItem, getItems } = useCheckout()

  const removeItem = useCallback(
    async (itemIndex: number) => {
      const itemToBeUpdated = {
        index: itemIndex,
        quantity: 0,
      }

      await updateItem(itemToBeUpdated)
    },
    [updateItem]
  )

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()

      if (!item) {
        return
      }

      const cart = getItems().map(({ productId, quantity, price }) => {
        return {
          productId,
          quantity,
          itemPrice: Number(price.replace(/\D/g, '')),
        }
      })

      dynamicYieldEvents([
        {
          name: 'Remove from Cart',
          properties: {
            cart: cart.filter(
              (cartItem) => cartItem.productId !== item.productId
            ),
            dyType: 'remove-from-cart-v1',
            currency: 'BRL',
            productId: item.id,
            value: Number(item.price.replace(/\D/g, '')),
            quantity: item.quantity,
          },
        },
      ])

      removeItem(item.itemIndex)
    },
    [getItems, item, removeItem]
  )

  return {
    onClick,
    'data-sku': item?.id ?? 0,
  }
}
